import { updateOutsideContactApi } from 'api/messenger/updateOutsideContactApi'

export const UPDATE_OUTSIDE_CONTACT = 'UPDATE_OUTSIDE_CONTACT' as const

export const updateOutsideContactAction = (
  serviceAlias: string,
  contact: string
) => ({
  type: UPDATE_OUTSIDE_CONTACT,
  promise: () => updateOutsideContactApi(serviceAlias, contact),
})
